export default "__VITE_ASSET__CpDOaYBC__"